// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__zVUYg","sendOtp":"AuthorizeToLogin_sendOtp__7d5cL"};